import React, { Fragment } from "react";
import { Card } from "@material-ui/core";
import WarningsAndHistoryList from "./WarningsAndHistoryList";
import ApplicationDetailTabs from "./ApplicationDetailTabs";
import ApplicationGeneralInfoList from "./ApplicationGeneralInfoList";
import ListingItem from "../../LisingItem";
import CreditOffersComponent from "../CreditOffersCmps/Credit.Offers.Component";
import { dateTimeFormater } from "../../../../../utilities/formaters";
import { getDeclineReasonText } from "./helper";

const ApplicationDetailsInternal = ({
  application,
  accountInfo,
  rejectCreditApplication,
  approveRejectCreditOffers,
  approveCreditOffer,
  rejectCreditOffer,
}) => {
  const cardStyle = { margin: "5px", padding: "10px 0" };
  const lineStyle = { float: "left", whiteSpace: "normal", marginLeft: "20px" };

  return (
    <React.Fragment>
      {application.LoanId == null && !application.disabled && (
        <div style={lineStyle}>
          <p>
            {application.ReplacedLoanId ? (
              <Fragment>
                <ListingItem primaryText={"Loan Replacement"} />
                Replaces loan: {application.ReplacedLoanId}
              </Fragment>
            ) : (
              <Fragment>
                <ListingItem primaryText={"Credit offers"} />
                {application.ExpiredAt ? (
                  <span>
                    <b>Expired at: {dateTimeFormater(application.ExpiredAt)}</b>
                    <br />
                  </span>
                ) : undefined}
                {application.DeclineReason ? (
                  <span>
                    <b>
                      Decline reason:{" "}
                      {getDeclineReasonText(application.DeclineReason)}
                    </b>
                    <br />
                  </span>
                ) : undefined}
                Set approval for offers without a decision:
              </Fragment>
            )}
          </p>
          <CreditOffersComponent
            creditOffers={application.CreditOffers}
            approveCreditOffer={approveCreditOffer}
            rejectCreditOffer={rejectCreditOffer}
            applicationId={application.Id}
            rejectCreditApplication={rejectCreditApplication}
            approveRejectCreditOffers={approveRejectCreditOffers}
          />
        </div>
      )}
      <Card style={cardStyle}>
        <ApplicationGeneralInfoList application={application} />
        <WarningsAndHistoryList application={application} />
        <div style={{ clear: "both" }} />
        <ApplicationDetailTabs
          application={application}
          accountInfo={accountInfo}
        />
      </Card>
    </React.Fragment>
  );
};

export default ApplicationDetailsInternal;
